import { render, staticRenderFns } from "./SuppliersInvoicesView3.vue?vue&type=template&id=4265b6c6&"
import script from "./SuppliersInvoicesView3.vue?vue&type=script&lang=js&"
export * from "./SuppliersInvoicesView3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports